const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;
const { InspectorControls, MediaUpload, MediaUploadCheck, RichText } = wp.editor;
const {Button,PanelBody,TextControl, ToggleControl, SelectControl,CheckboxControl,FormTokenField,
  __experimentalNumberControl, ColorPicker, ResponsiveWrapper,} = wp.components;
  const { getCurrentPostId } = wp.data.select('core/editor');
  const { StyleSelector, PageSelect, FlexSelector, PagesTags } = wp.easy_email_integrationComponent;

  
class EditBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      submitted: false,
      formData: {
        name: '',
        email: '',
        consent: false,
      },
      styleObj: {},
      styleBgObj: {},
      integrationObj:{},
    };
    this.submitDemo = this.submitDemo.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
  }
  // Design 
  componentDidMount = () => {
    this.props.setAttributes({ post_id: getCurrentPostId() });
    this.runApiFetch();

    const { backgroundType, backgroundColor, color,backgroundImage } =this.props.attributes;
    if (backgroundType === 'color') {
      this.setState({ styleObj: { backgroundColor: backgroundColor } });
    } 
    //N
    else if(backgroundType === 'text') {
      this.setState({
        styleObj:{
          color: color?color: 'none',
        },
        styleBgObj:{
          backgroundColor: backgroundColor?backgroundColor: 'none',
        }
      })
    } 
    //
    else if (backgroundType === 'image') {
      this.setState({
        styleBgObj: {
          backgroundImage: backgroundImage?.url
            ? `url(${backgroundImage.url})`
            : 'none',
        },
      });
    } else {
      this.setState({ styleBgObj: {} });
    }
  };

  changeHandler = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  runApiFetch() {
		wp.apiFetch({
			path: `eei/v1/integrations`,
		}).then(data => {
			this.setState({ integrationObj: {data} })
		});
	}

  submitDemo = (e) => {
    e.preventDefault();
    const { name, email, consent } = this.state.formData;
    const {
      nameFieldDisplay,
      nameFieldIsRequired,
      nameFieldErrorMsg,
      emailErrorMsg,
      consentCheckbox,
      consentErrorMsg,
    } = this.props.attributes;
    this.setState({ error: '' });

    if (nameFieldDisplay && nameFieldIsRequired) {
      if (!name) {
        this.setState({ error: nameFieldErrorMsg });
        return;
      }
    }

    if (!email) {
      this.setState({ error: emailErrorMsg });
      return;
    }

    if (!validateEmail(email)) {
      this.setState({ error: emailErrorMsg });
      return;
    }

    if (consentCheckbox) {
      if (!consent) {
        this.setState({ error: consentErrorMsg });
        return;
      }
    }

    this.setState({ submitted: true });
  };
  
  render() {
    const {
      attributes: {
        formName,
        formTag,
        formAllIntegration,
        formWidth,
        formDoubleOptIn,
        formStyle,
        headingText,
        subHeadingDisplay,
        subHeadingText,
        nameFieldDisplay,
        nameFieldIsRequired,
        nameFieldPlaceholder,
        nameFieldErrorMsg,
        firstnameLastnameFieldDisplay,
        phoneFieldDisplay,
        phoneFieldRequired,
        emailPlaceholder,
        emailErrorMsg,
        consentCheckbox,
        consentText,
        consentErrorMsg,
        btnText,
        btnSubmisisonAction,
        btnSubmisisonThankYouMsg,
        btnSubmisisonErrorMsg,
        btnSubmissionThankYouPage,
        post_id,
        backgroundType,
        backgroundColor,
        color,
        backgroundImage,
      },
      setAttributes,
      setState,
    } = this.props;

    const {
      error,
      submitted,
      formData: { name, email, consent },
      styleBgObj, 
      styleObj,  
      integrationObj
    } = this.state;
    /**
     * Integration
     */
    const getKeys = [];
    const getName = [];
    if(integrationObj.data !== undefined){
      integrationObj.data.forEach(IntegrationBrekdown);
      function IntegrationBrekdown(insideIntegration, Integrationkeys, arr) {
        const activated = insideIntegration.activated;
        const keys = insideIntegration.key;
        const name = insideIntegration.name;
        if(activated == true){
          getKeys.push(keys); 
          getName.push(name); 
        }else{
          return
        }
      }
    }
    const result = getName.map((label, index) => ({label, value: getKeys[index]}));

    return (
      <Fragment>
        <InspectorControls key="inspector">
          <PanelBody
            title={__('Style', 'easy-email-integration')}
            initialOpen={true}
          >
            <StyleSelector
              value={formStyle}
              onChange={(val) => setAttributes({ formStyle: val })}
              options={[
                { value: 1, styleIcon: 1 },
                { value: 2, styleIcon: 2 },
                { value: 3, styleIcon: 3 },
                { value: 4, styleIcon: 4 },
                { value: 5, styleIcon: 5 },
              ]}
            />
          </PanelBody>

          {/* Integration  */}
          <PanelBody
            title={__('Integrations', 'easy-email-integration')}
            initialOpen={false}
          >
            <SelectControl
              label={__('Activated Integration', 'easy-email-integration')}
              multiple
              value={formAllIntegration}
              options = {result}
              __nextHasNoMarginBottom
              placeholder={__('Ex: General', 'easy-email-integration')}
              onChange={(val) => setAttributes({ formAllIntegration: val })}
              className= "isEEISelectControl"
            /> 

          </PanelBody>

          <PanelBody
            title={__('Configuration', 'easy-email-integration')}
            initialOpen={false}
          >
            <TextControl
              label={__('Form name', 'easy-email-integration')}
              value={formName}
              placeholder={__('Ex: Sample Form', 'easy-email-integration')}
              onChange={(val) => setAttributes({ formName: val })}
            />
          
            <PagesTags
                label={__('Form tag', 'easy-email-integration')}
                value={formTag}
                onChange={(val) => { setAttributes({ formTag: val });
                }}
              />
            <__experimentalNumberControl
              className="components-base-control"
              isShiftStepEnabled={true}
              label={__('Width', 'easy-email-integration')}
              onChange={(val) => setAttributes({ formWidth: val })}
              shiftStep={10}
              value={formWidth}
            />
            
            <ToggleControl
              label={__('Double opt-in', 'easy-email-integration')}
              checked={formDoubleOptIn}
              onChange={() =>
                setAttributes({ formDoubleOptIn: !formDoubleOptIn })
              }
            />

            <ToggleControl
              label={__('Show subheading', 'easy-email-integration')}
              checked={subHeadingDisplay}
              onChange={() =>
                setAttributes({ subHeadingDisplay: !subHeadingDisplay })
              }
            />
            <ToggleControl
              label={__('Use name field', 'easy-email-integration')}
              checked={nameFieldDisplay}
              onChange={() =>
                setAttributes({ nameFieldDisplay: !nameFieldDisplay })
              }
            />
            {nameFieldDisplay && (
              <span>
                <ToggleControl
                  label={__('Is name required', 'easy-email-integration')}
                  checked={nameFieldIsRequired}
                  onChange={() =>
                    setAttributes({ nameFieldIsRequired: !nameFieldIsRequired })
                  }
                />
                <TextControl
                  label={__('Name placeholder', 'easy-email-integration')}
                  value={nameFieldPlaceholder}
                  onChange={(val) =>
                    setAttributes({ nameFieldPlaceholder: val })
                  }
                />
              </span>
            )}
            {nameFieldDisplay && nameFieldIsRequired && (
              <TextControl
                label={__('Name error message', 'easy-email-integration')}
                value={nameFieldErrorMsg}
                onChange={(val) => setAttributes({ nameFieldErrorMsg: val })}
              />
            )}
            <ToggleControl
              label={__(
                'Use firstname & lastname field',
                'easy-email-integration'
              )}
              checked={firstnameLastnameFieldDisplay}
              onChange={() =>
                setAttributes({
                  firstnameLastnameFieldDisplay: !firstnameLastnameFieldDisplay,
                })
              }
            />
            <ToggleControl
              label={__('Use phone field', 'easy-email-integration')}
              checked={phoneFieldDisplay}
              onChange={() =>
                setAttributes({
                  phoneFieldDisplay: !phoneFieldDisplay,
                })
              }
            />
            {phoneFieldDisplay && (
              <ToggleControl
                label={__('Is phone required', 'easy-email-integration')}
                checked={phoneFieldRequired}
                onChange={() =>
                  setAttributes({
                    phoneFieldRequired: !phoneFieldRequired,
                  })
                }
              />
            )}
            <TextControl
              label={__('Email placeholder', 'easy-email-integration')}
              value={emailPlaceholder}
              onChange={(val) => setAttributes({ emailPlaceholder: val })}
            />
            <TextControl
              label={__('Email error message', 'easy-email-integration')}
              value={emailErrorMsg}
              onChange={(val) => setAttributes({ emailErrorMsg: val })}
            />
            <ToggleControl
              label={__('Show consent check', 'easy-email-integration')}
              checked={consentCheckbox}
              onChange={() =>
                setAttributes({ consentCheckbox: !consentCheckbox })
              }
            />
            {consentCheckbox && (
              <React.Fragment>
                <TextControl
                  label={__('Consent error message', 'easy-email-integration')}
                  value={consentErrorMsg}
                  onChange={(val) => setAttributes({ consentErrorMsg: val })}
                />
              </React.Fragment>
            )}
            <SelectControl
              label={__('Button submission action')}
              value={btnSubmisisonAction}
              options={[
                { label: __('Custom Message', 'easy-email-integration'), value: 'custom_msg' },
                { label: __('Hide Form', 'easy-email-integration'), value: 'hide_form' },
                { label: __('Redirect to page', 'easy-email-integration'), value: 'redirect' },
              ]}
              onChange={(val) => setAttributes({ btnSubmisisonAction: val })}
            />
            {btnSubmisisonAction === 'custom_msg' && (
              <TextControl
                label={__('Thank you message', 'easy-email-integration')}
                value={btnSubmisisonThankYouMsg}
                onChange={(val) =>
                  setAttributes({ btnSubmisisonThankYouMsg: val })
                }
              />
            )}
            {btnSubmisisonAction === 'redirect' && (
              <PageSelect
                label={__('Select thank you page', 'easy-email-integration')}
                value={btnSubmissionThankYouPage}
                onChange={(val) =>
                  setAttributes({ btnSubmissionThankYouPage: val })
                }
              />
            )}
            <TextControl
              label={__('Error message', 'easy-email-integration')}
              value={btnSubmisisonErrorMsg}
              onChange={(val) => setAttributes({ btnSubmisisonErrorMsg: val })}
            />
          </PanelBody>

          {/* Design  */}
          <PanelBody
            title={__('Design', 'easy-email-integration')}
            initialOpen={false}
          >
            <FlexSelector
              label={__('Background type', 'easy-email-integration')}
              value={backgroundType}
              onChange={(val) => {
                setAttributes({ backgroundType: val });
                if (val === 'color') {
                  this.setState({ styleBgObj: { backgroundColor } });
                } 
                else if (val === 'text') {
                  this.setState({ styleObj: { color }, styleBgObj: { backgroundColor } });
                } 
                
                else if (val === 'image') {
                  this.setState({
                    styleBgObj: {
                      backgroundImage: backgroundImage?.url? `url(${backgroundImage.url})` : 'none',
                    },
                  });
                } else {
                  this.setState({ styleObj: {},styleBgObj:{} });
                }
              }}
              options={[
                { value: 'default', label: __('Default', 'easy-email-integration') },
                { value: 'color', label: __('BGColor', 'easy-email-integration') },
                { value: 'text', label: __('Color', 'easy-email-integration') },
                { value: 'image', label: __('Image', 'easy-email-integration') },
              ]}
            />
            {backgroundType === 'color' && (
              <ColorPicker
                color={backgroundColor}
                onChange={(val) => {
                  setAttributes({ backgroundColor: val });
                  this.setState({
                    styleBgObj: { ...this.state.styleBgObj, backgroundColor: val },
                  });
                }}
                enableAlpha
                defaultValue={backgroundColor}
              />
            )}
            {backgroundType === 'text' && (
              <ColorPicker
                color={color}
                onChange={(val) => {
                  setAttributes({ color: val });
                  this.setState({
                    styleObj: { ...this.state.styleObj, color: val },
                  });
                }}
                enableAlpha
                defaultValue={color}
              />
            )}
            {backgroundType === 'image' && (
              <div className="eei-image-selector-wrap">
                <MediaUploadCheck
                  fallback={
                    <p>
                      {__(
                        'To edit the background image, you need permission to upload media.',
                        'easy-email-integration'
                      )}
                    </p>
                  }
                >
                  <MediaUpload
                    title={__('Background image', 'easy-email-integration')}
                    onSelect={(val) => {
                      setAttributes({ backgroundImage: val });
                      this.setState({
                        styleBgObj: {
                          ...this.state.styleBgObj,
                          backgroundImage: val?.url
                            ? `url(${val.url})`
                            : 'none',
                        },
                      });
                    }}
                    allowedTypes={['image']}
                    value={backgroundImage}
                    render={({ open }) => (
                      <Button
                        className={
                          !backgroundImage
                            ? 'eei-bg-image__toggle'
                            : 'eei-bg-image__preview'
                        }
                        onClick={open}
                      >
                        {!backgroundImage &&
                          __('Set background image', 'easy-email-integration')}
                        {backgroundImage && (
                          <ResponsiveWrapper
                            naturalWidth={backgroundImage.width}
                            naturalHeight={backgroundImage.height}
                          >
                            <img
                              src={backgroundImage.sizes.medium.url}
                              alt={__(
                                'Background image',
                                'easy-email-integration'
                              )}
                            />
                          </ResponsiveWrapper>
                        )}
                      </Button>
                    )}
                  />
                </MediaUploadCheck>
                {backgroundImage && (
                  <MediaUploadCheck>
                    <div className="eei-image-selector-btns">
                      <MediaUpload
                        title={__('Background image', 'easy-email-integration')}
                        onSelect={(val) => {
                          setAttributes({ backgroundImage: val });
                          this.setState({
                            styleBgObj: {
                              ...this.state.styleBgObj,
                              backgroundImage: val?.url
                                ? `url(${val.url})`
                                : 'none',
                            },
                          });
                        }}
                        allowedTypes={['image']}
                        value={backgroundImage}
                        render={({ open }) => (
                          <Button onClick={open} isDefault isLarge>
                            {__('Replace', 'easy-email-integration')}
                          </Button>
                        )}
                      />
                      <Button
                        onClick={() => {
                          setAttributes({ backgroundImage: null });
                          this.setState({
                            styleBgObj: {
                              ...this.state.styleBgObj,
                              backgroundImage: 'none',
                            },
                          });
                        }}
                        isLink
                        isDestructive
                      >
                        {__('Remove', 'easy-email-integration')}
                      </Button>
                    </div>
                  </MediaUploadCheck>
                )}
              </div>
            )}
          </PanelBody>
        </InspectorControls>
        <form
          method="post"
          className={`easy-email-integration style-${formStyle}`}
          style={{
            ...styleBgObj,
            ...styleObj,
            maxWidth: `${formWidth}px`,
          }}
          onSubmit={this.submitDemo}
        >
          {formStyle === 1 && (
            <React.Fragment>
              {subHeadingDisplay && (
                <RichText
                  className="easy_email_integration-subtitle"
                  tagName="h5"
                  style={backgroundType === 'text'  || backgroundType === 'image'  ? {color} : null}
                  value={subHeadingText}
                  allowedFormats={ [ 'core/bold', 'core/italic' ] }
                  onChange={ ( val ) => setAttributes( { subHeadingText: val } ) }
                  placeholder={ __( 'Subheading...', 'easy-email-integration' ) }
                />
              )}
              <RichText
                className="easy_email_integration-title"
                tagName="h3"
                style={backgroundType === 'text'  || backgroundType === 'image'  ? {color} : null}
                value={headingText}
                allowedFormats={ [ 'core/bold', 'core/italic' ] }
                onChange={ ( val) => setAttributes( { headingText: val } ) }
                placeholder={ __( 'Heading...', 'easy-email-integration' ) }
              />
              {error ? (
                <p className="easy_email_integration-err-msg">{error}</p>
              ) : (
                ''
              )}
              {firstnameLastnameFieldDisplay ? (
                <div className="seperate_name_fields">
                  <input
                    type="text"
                    name="firstname"
                    placeholder={__(
                      'Your First Name',
                      'easy-email-integration'
                    )}
                  />
                  <input
                    type="text"
                    name="lastname"
                    placeholder={__('Your Last Name', 'easy-email-integration')}
                  />
                </div>
              ) : null}
              {nameFieldDisplay ? (
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={this.changeHandler}
                  placeholder={`${nameFieldPlaceholder} ${
                    nameFieldIsRequired ? '*' : ''
                  }`}
                />
              ) : null}
              <input
                type="email"
                name="email"
                value={email}
                onChange={this.changeHandler}
                placeholder={`${emailPlaceholder} *`}
              />
              {phoneFieldDisplay && (
                <input
                  type="tel"
                  name="phone"
                  required={phoneFieldRequired}
                  placeholder={__(
                    `Your Phone Number ${phoneFieldRequired ? '*' : ''}`,
                    'easy-email-integration'
                  )}
                />
              )}
              {consentCheckbox && (
                <div className="wcf-consent-label">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={consent}
                    onChange={() =>
                      this.setState({
                        formData: { ...this.state.formData, consent: !consent },
                      })
                    }
                  />
                  <RichText
                    tagName="span"
                    value={consentText}
                    allowedFormats={ [] }
                    onChange={ ( val ) => setAttributes( { consentText: val } ) }
                    placeholder={ __( 'Consent Text...', 'easy-email-integration' ) }
                  />
                </div>
              )}
              <RichText
                tagName="button"
                type="submit"
                value={btnText}
                allowedFormats={ [] }
                onChange={ ( val ) => setAttributes( { btnText: val } ) }
                onClick={(e) => e.preventDefault()}
                placeholder={ __( 'Button Text...', 'easy-email-integration' ) }
              />
              {submitted && (
                <div className="wcf-thankyou">
                  <div className="wcf-thankyou-content">
                    <svg
                      className="wcf-thankyou-close"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      onClick={() => setState({ submitted: false })}
                    >
                      <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="Wcf-thankyou-icon"
                    >
                      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" />
                    </svg>
                    <p>{btnSubmisisonThankYouMsg}</p>
                  </div>
                </div>
              )}
              <input type="hidden" name="post_id" value={post_id} />
              <input
                type="hidden"
                name="success_msg"
                value={btnSubmisisonThankYouMsg}
              />
              <input
                type="hidden"
                name="error_msg"
                value={btnSubmisisonErrorMsg}
              />
            </React.Fragment>
          )}
          {formStyle === 2 && (
            <React.Fragment>
              <RichText
                className="easy_email_integration-title"
                tagName="h3"
                style={backgroundType === 'text'  || backgroundType === 'image'  ? {color} : null}
                value={headingText}
                allowedFormats={ [ 'core/bold', 'core/italic' ] }
                onChange={ ( val) => setAttributes( { headingText: val } ) }
                placeholder={ __( 'Heading...', 'easy-email-integration' ) }
              />
              {subHeadingDisplay && (
                <RichText
                  className="easy_email_integration-subtitle"
                  tagName="h5"
                  style={backgroundType === 'text'  || backgroundType === 'image'  ? {color} : null}
                  value={subHeadingText}
                  allowedFormats={ [ 'core/bold', 'core/italic' ] }
                  onChange={ ( val ) => setAttributes( { subHeadingText: val } ) }
                  placeholder={ __( 'Subheading...', 'easy-email-integration' ) }
                />
              )}
              {error ? (
                <p className="easy_email_integration-err-msg">{error}</p>
              ) : (
                ''
              )}
              <div className="eei-form-flex">
                {firstnameLastnameFieldDisplay ? (
                  <React.Fragment>
                    <input
                      type="text"
                      name="firstname"
                      placeholder={__(
                        'Your First Name',
                        'easy-email-integration'
                      )}
                    />
                    <input
                      type="text"
                      name="lastname"
                      placeholder={__(
                        'Your Last Name',
                        'easy-email-integration'
                      )}
                    />
                  </React.Fragment>
                ) : null}
                {nameFieldDisplay ? (
                  <input
                    type="text"
                    name="name"
                    value={name}
                    onChange={this.changeHandler}
                    placeholder={`${nameFieldPlaceholder} ${
                      nameFieldIsRequired ? '*' : ''
                    }`}
                  />
                ) : null}
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.changeHandler}
                  placeholder={`${emailPlaceholder} *`}
                />
                {phoneFieldDisplay && (
                  <input
                    type="tel"
                    name="phone"
                    required={phoneFieldRequired}
                    placeholder={__(
                      `Your Phone Number ${phoneFieldRequired ? '*' : ''}`,
                      'easy-email-integration'
                    )}
                  />
                )}
                <RichText
                  tagName="button"
                  type="submit"
                  value={btnText}
                  allowedFormats={ [] }
                  onChange={ ( val ) => setAttributes( { btnText: val } ) }
                  onClick={(e) => e.preventDefault()}
                  placeholder={ __( 'Button Text...', 'easy-email-integration' ) }
                />
              </div>
              {consentCheckbox && (
                <div className="wcf-consent-label">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={consent}
                    onChange={() =>
                      this.setState({
                        formData: { ...this.state.formData, consent: !consent },
                      })
                    }
                  />
                  <RichText
                    tagName="span"
                    value={consentText}
                    allowedFormats={ [] }
                    onChange={ ( val ) => setAttributes( { consentText: val } ) }
                    placeholder={ __( 'Consent Text...', 'easy-email-integration' ) }
                  />
                </div>
              )}
              {submitted && (
                <div className="wcf-thankyou">
                  <div className="wcf-thankyou-content">
                    <svg
                      className="wcf-thankyou-close"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      onClick={() => setState({ submitted: false })}
                    >
                      <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="Wcf-thankyou-icon"
                    >
                      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" />
                    </svg>
                    <p>{btnSubmisisonThankYouMsg}</p>
                  </div>
                </div>
              )}
              <input type="hidden" name="post_id" value={post_id} />
              <input
                type="hidden"
                name="success_msg"
                value={btnSubmisisonThankYouMsg}
              />
              <input
                type="hidden"
                name="error_msg"
                value={btnSubmisisonErrorMsg}
              />
            </React.Fragment>
          )}
          {formStyle === 3 && (
            <React.Fragment>
              <div className="eei-form-header">
                <RichText
                  className="easy_email_integration-title"
                  tagName="h3"
                  style={backgroundType === 'text' || backgroundType === 'image' ? {color} : null}
                  value={headingText}
                  allowedFormats={ [ 'core/bold', 'core/italic' ] }
                  onChange={ ( val) => setAttributes( { headingText: val } ) }
                  placeholder={ __( 'Heading...', 'easy-email-integration' ) }
                />
                {subHeadingDisplay && (
                  <RichText
                    className="easy_email_integration-subtitle"
                    tagName="h5"
                    style={backgroundType === 'text' || backgroundType === 'image' ? {color} : null}
                    value={subHeadingText}
                    allowedFormats={ [ 'core/bold', 'core/italic' ] }
                    onChange={ ( val ) => setAttributes( { subHeadingText: val } ) }
                    placeholder={ __( 'Subheading...', 'easy-email-integration' ) }
                  />
                )}
                {error ? (
                  <p className="easy_email_integration-err-msg">{error}</p>
                ) : (
                  ''
                )}
              </div>
              <div className="eei-form-body">
                {firstnameLastnameFieldDisplay ? (
                  <div className="seperate_name_fields">
                    <input
                      type="text"
                      name="firstname"
                      placeholder={__(
                        'Your First Name',
                        'easy-email-integration'
                      )}
                    />
                    <input
                      type="text"
                      name="lastname"
                      placeholder={__(
                        'Your Last Name',
                        'easy-email-integration'
                      )}
                    />
                  </div>
                ) : null}
                {nameFieldDisplay ? (
                  <input
                    type="text"
                    name="name"
                    value={name}
                    onChange={this.changeHandler}
                    placeholder={`${nameFieldPlaceholder} ${
                      nameFieldIsRequired ? '*' : ''
                    }`}
                  />
                ) : null}
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.changeHandler}
                  placeholder={`${emailPlaceholder} *`}
                />
                {phoneFieldDisplay && (
                  <input
                    type="tel"
                    name="phone"
                    required={phoneFieldRequired}
                    placeholder={__(
                      `Your Phone Number ${phoneFieldRequired ? '*' : ''}`,
                      'easy-email-integration'
                    )}
                  />
                )}
                {consentCheckbox && (
                  <div className="wcf-consent-label">
                    <input
                      type="checkbox"
                      name="consent"
                      checked={consent}
                      onChange={() =>
                        this.setState({
                          formData: { ...this.state.formData, consent: !consent },
                        })
                      }
                    />
                    <RichText
                      tagName="span"
                      value={consentText}
                      allowedFormats={ [] }
                      onChange={ ( val ) => setAttributes( { consentText: val } ) }
                      placeholder={ __( 'Consent Text...', 'easy-email-integration' ) }
                    />
                  </div>
                )}
                <RichText
                  tagName="button"
                  type="submit"
                  value={btnText}
                  allowedFormats={ [] }
                  onChange={ ( val ) => setAttributes( { btnText: val } ) }
                  onClick={(e) => e.preventDefault()}
                  placeholder={ __( 'Button Text...', 'easy-email-integration' ) }
                />
              </div>
              {submitted && (
                <div className="wcf-thankyou">
                  <div className="wcf-thankyou-content">
                    <svg
                      className="wcf-thankyou-close"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      onClick={() => setState({ submitted: false })}
                    >
                      <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="Wcf-thankyou-icon"
                    >
                      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" />
                    </svg>
                    <p>{btnSubmisisonThankYouMsg}</p>
                  </div>
                </div>
              )}
              <input type="hidden" name="post_id" value={post_id} />
              <input
                type="hidden"
                name="success_msg"
                value={btnSubmisisonThankYouMsg}
              />
              <input
                type="hidden"
                name="error_msg"
                value={btnSubmisisonErrorMsg}
              />
            </React.Fragment>
          )}
          {formStyle === 4 && (
            <div>
              <div className="eei-form-header">
                {subHeadingDisplay && (
                  <RichText
                    className="easy_email_integration-subtitle"
                    tagName="h5"
                    style={backgroundType === 'text' || backgroundType === 'image' ? {color} : null}
                    value={subHeadingText}
                    allowedFormats={ [ 'core/bold', 'core/italic' ] }
                    onChange={ ( val ) => setAttributes( { subHeadingText: val } ) }
                    placeholder={ __( 'Subheading...', 'easy-email-integration' ) }
                  />
                )}
                <RichText
                  className="easy_email_integration-title"
                  tagName="h3"
                  style={backgroundType === 'text' || backgroundType === 'image' ? {color} : null}
                  value={headingText}
                  allowedFormats={ [ 'core/bold', 'core/italic' ] }
                  onChange={ ( val) => setAttributes( { headingText: val } ) }
                  placeholder={ __( 'Heading...', 'easy-email-integration' ) }
                />
                {error ? (
                  <p className="easy_email_integration-err-msg">{error}</p>
                ) : (
                  ''
                )}
              </div>
              <div className="eei-form-body">
                {firstnameLastnameFieldDisplay ? (
                  <div className="seperate_name_fields">
                    <input
                      type="text"
                      name="firstname"
                      placeholder={__(
                        'Your First Name',
                        'easy-email-integration'
                      )}
                    />
                    <input
                      type="text"
                      name="lastname"
                      placeholder={__(
                        'Your Last Name',
                        'easy-email-integration'
                      )}
                    />
                  </div>
                ) : null}
                {nameFieldDisplay ? (
                  <input
                    type="text"
                    name="name"
                    value={name}
                    onChange={this.changeHandler}
                    placeholder={`${nameFieldPlaceholder} ${
                      nameFieldIsRequired ? '*' : ''
                    }`}
                  />
                ) : null}
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.changeHandler}
                  placeholder={`${emailPlaceholder} *`}
                />
                {phoneFieldDisplay && (
                  <input
                    type="tel"
                    name="phone"
                    required={phoneFieldRequired}
                    placeholder={__(
                      `Your Phone Number ${phoneFieldRequired ? '*' : ''}`,
                      'easy-email-integration'
                    )}
                  />
                )}
                <RichText
                  tagName="button"
                  type="submit"
                  value={btnText}
                  allowedFormats={ [] }
                  onChange={ ( val ) => setAttributes( { btnText: val } ) }
                  onClick={(e) => e.preventDefault()}
                  placeholder={ __( 'Button Text...', 'easy-email-integration' ) }
                />
              </div>
              {consentCheckbox && (
                <div className="wcf-consent-label">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={consent}
                    onChange={() =>
                      this.setState({
                        formData: { ...this.state.formData, consent: !consent },
                      })
                    }
                  />
                  <RichText
                    tagName="span"
                    value={consentText}
                    allowedFormats={ [] }
                    onChange={ ( val ) => setAttributes( { consentText: val } ) }
                    placeholder={ __( 'Consent Text...', 'easy-email-integration' ) }
                  />
                </div>
              )}
              {submitted && (
                <div className="wcf-thankyou">
                  <div className="wcf-thankyou-content">
                    <svg
                      className="wcf-thankyou-close"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      onClick={() => setState({ submitted: false })}
                    >
                      <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="Wcf-thankyou-icon"
                    >
                      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" />
                    </svg>
                    <p>{btnSubmisisonThankYouMsg}</p>
                  </div>
                </div>
              )}
              <input type="hidden" name="post_id" value={post_id} />
              <input
                type="hidden"
                name="success_msg"
                value={btnSubmisisonThankYouMsg}
              />
              <input
                type="hidden"
                name="error_msg"
                value={btnSubmisisonErrorMsg}
              />
            </div>
          )}
          {formStyle === 5 && (
            <React.Fragment>
              <div className="eei-form-body">
                <div className="eei-form-header">
                  <RichText
                    className="easy_email_integration-title"
                    tagName="h3"
                    style={backgroundType === 'text' || backgroundType === 'image' ? {color} : null}
                    value={headingText}
                    allowedFormats={ [ 'core/bold', 'core/italic' ] }
                    onChange={ ( val) => setAttributes( { headingText: val } ) }
                    placeholder={ __( 'Heading...', 'easy-email-integration' ) }
                  />
                  {subHeadingDisplay && (
                    <RichText
                      className="easy_email_integration-subtitle"
                      tagName="h5"
                      style={backgroundType === 'text' || backgroundType === 'image' ? {color} : null}
                      value={subHeadingText}
                      allowedFormats={ [ 'core/bold', 'core/italic' ] }
                      onChange={ ( val ) => setAttributes( { subHeadingText: val } ) }
                      placeholder={ __( 'Subheading...', 'easy-email-integration' ) }
                    />
                  )}
                  {error ? (
                    <p className="easy_email_integration-err-msg">{error}</p>
                  ) : (
                    ''
                  )}
                </div>
                {firstnameLastnameFieldDisplay ? (
                  <div className="seperate_name_fields">
                    <input
                      type="text"
                      name="firstname"
                      placeholder={__(
                        'Your First Name',
                        'easy-email-integration'
                      )}
                    />
                    <input
                      type="text"
                      name="lastname"
                      placeholder={__(
                        'Your Last Name',
                        'easy-email-integration'
                      )}
                    />
                  </div>
                ) : null}
                {nameFieldDisplay ? (
                  <input
                    type="text"
                    name="name"
                    value={name}
                    onChange={this.changeHandler}
                    placeholder={`${nameFieldPlaceholder} ${
                      nameFieldIsRequired ? '*' : ''
                    }`}
                  />
                ) : null}
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.changeHandler}
                  placeholder={`${emailPlaceholder} *`}
                />
                {phoneFieldDisplay && (
                  <input
                    type="tel"
                    name="phone"
                    required={phoneFieldRequired}
                    placeholder={__(
                      `Your Phone Number ${phoneFieldRequired ? '*' : ''}`,
                      'easy-email-integration'
                    )}
                  />
                )}
                {consentCheckbox && (
                  <div className="wcf-consent-label">
                    <input
                      type="checkbox"
                      name="consent"
                      checked={consent}
                      onChange={() =>
                        this.setState({
                          formData: { ...this.state.formData, consent: !consent },
                        })
                      }
                    />
                    <RichText
                      tagName="span"
                      value={consentText}
                      allowedFormats={ [] }
                      onChange={ ( val ) => setAttributes( { consentText: val } ) }
                      placeholder={ __( 'Consent Text...', 'easy-email-integration' ) }
                    />
                  </div>
                )}
                <RichText
                  tagName="button"
                  type="submit"
                  value={btnText}
                  allowedFormats={ [] }
                  onChange={ ( val ) => setAttributes( { btnText: val } ) }
                  onClick={(e) => e.preventDefault()}
                  placeholder={ __( 'Button Text...', 'easy-email-integration' ) }
                />
                <input type="hidden" name="post_id" value={post_id} />
                <input
                  type="hidden"
                  name="success_msg"
                  value={btnSubmisisonThankYouMsg}
                />
                <input
                  type="hidden"
                  name="error_msg"
                  value={btnSubmisisonErrorMsg}
                />
              </div>
              <div className="eei-form-image">
                {backgroundType === 'image' &&
                backgroundImage !== null &&
                backgroundImage.url ? (
                  <img src={backgroundImage.url} alt={headingText} />
                ) : (
                  <svg width="270" height="310" viewBox="0 0 270 310" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2_16)">
                  <rect width="270" height="310" fill="white"/>
                  <path d="M270 85.0549V238.365C202.593 233.018 147.237 249.462 102.035 277.536C61.3572 273.166 25.1227 276.583 0 280.775V274.974C34.6962 223.46 56.8095 169.264 70.6243 117.68C129.217 92.0358 198.334 74.8563 270 85.0549Z" fill="url(#paint0_radial_2_16)"/>
                  <path d="M270 24.3259V85.0549C198.331 74.8563 129.217 92.0358 70.6243 117.68C74.1637 104.465 77.1577 91.426 79.6768 78.641C81.4021 77.6297 83.1335 76.6337 84.8649 75.6592C85.4441 75.3344 86.0202 75.0126 86.5964 74.6908C87.1725 74.366 87.7517 74.0473 88.3278 73.7347C88.907 73.416 89.4862 73.1004 90.0623 72.7878C91.7938 71.8501 93.5313 70.9276 95.2689 70.0206C95.8481 69.7202 96.4273 69.4199 97.0034 69.1226C97.5611 68.8346 98.1219 68.5496 98.6797 68.2646C99.2803 67.9581 99.8779 67.6578 100.475 67.3606C101.055 67.0694 101.634 66.7844 102.213 66.4964C102.792 66.2083 103.371 65.9264 103.948 65.6445C105.707 64.7864 107.466 63.9467 109.222 63.1285C109.776 62.868 110.337 62.6075 110.892 62.3532C112.053 61.8138 113.208 61.2868 114.367 60.7689C114.946 60.5114 115.525 60.251 116.098 59.9966C117.833 59.2243 119.567 58.4705 121.296 57.7381C121.872 57.4929 122.451 57.2478 123.024 57.0087C125.154 56.1108 127.284 55.2405 129.407 54.3916C130.155 54.0913 130.9 53.7971 131.647 53.506C132.221 53.2823 132.791 53.0586 133.364 52.8379C133.845 52.651 134.326 52.4641 134.807 52.2833C136.682 51.5662 138.552 50.8675 140.418 50.1872C140.875 50.0186 141.331 49.8531 141.788 49.6907C142.398 49.467 143.011 49.2464 143.62 49.0319C144.347 48.7744 145.076 48.517 145.799 48.2657C146.434 48.042 147.065 47.8214 147.699 47.6099C148.821 47.2207 149.942 46.8407 151.061 46.4699C151.64 46.2738 152.222 46.0807 152.799 45.8938C153.571 45.6395 154.343 45.3851 155.115 45.1369C155.783 44.9193 156.454 44.7048 157.123 44.4964C157.561 44.3554 158.002 44.2145 158.44 44.0827C160.935 43.2982 163.417 42.5443 165.884 41.8242C166.285 41.7047 166.684 41.5882 167.082 41.4718C168.437 41.0795 169.782 40.6964 171.124 40.3195C171.875 40.1081 172.623 39.9027 173.374 39.6974C173.456 39.676 173.542 39.6484 173.625 39.6269C174.29 39.4461 174.952 39.2653 175.614 39.0906C177.112 38.6892 178.605 38.2969 180.088 37.9169C180.817 37.73 181.547 37.5431 182.273 37.3623C183.005 37.1784 183.741 36.9945 184.47 36.8168C184.605 36.7861 184.74 36.7494 184.875 36.7187C186.928 36.2162 188.966 35.732 190.991 35.2662C191.708 35.1007 192.425 34.9383 193.136 34.7789C195.993 34.1384 198.812 33.5317 201.594 32.9678C204.377 32.3978 207.123 31.8615 209.823 31.362C211.174 31.1107 212.513 30.8686 213.84 30.6388C215.838 30.2833 217.806 29.9523 219.748 29.6367C221.691 29.318 223.607 29.0207 225.497 28.7388C226.129 28.6438 226.754 28.5519 227.379 28.4599C229.561 28.1412 231.706 27.844 233.811 27.5712C234.872 27.4303 235.926 27.2954 236.962 27.1698C237.149 27.1483 237.336 27.1238 237.519 27.1024C238.564 26.9706 239.594 26.8511 240.615 26.7316C240.756 26.7162 240.903 26.7009 241.041 26.6825C241.843 26.5875 242.634 26.5017 243.416 26.4159C243.979 26.3516 244.537 26.2933 245.092 26.2382C245.925 26.1493 246.753 26.0635 247.568 25.9838C248.11 25.9287 248.653 25.8766 249.189 25.8245C249.725 25.7724 250.259 25.7233 250.789 25.6743C251.316 25.6222 251.843 25.5793 252.364 25.5303C252.719 25.4996 253.069 25.4659 253.418 25.4383C253.758 25.4108 254.092 25.3801 254.429 25.3525C255.027 25.3004 255.615 25.2545 256.201 25.2054C256.954 25.1441 257.696 25.0859 258.432 25.0338C258.689 25.0154 258.949 24.994 259.207 24.9756C259.676 24.9419 260.142 24.9082 260.604 24.8775C262.317 24.755 263.978 24.6508 265.578 24.5588C265.93 24.5404 266.277 24.519 266.623 24.5006C267.453 24.4516 268.265 24.4117 269.062 24.3719C269.396 24.3535 269.7 24.3382 270 24.3259Z" fill="url(#paint1_radial_2_16)"/>
                  <path d="M102.035 277.536C59.6043 303.878 26.1156 340.474 0 378.912V280.775C25.1227 276.583 61.3572 273.166 102.035 277.536Z" fill="url(#paint2_radial_2_16)"/>
                  <path d="M270 238.365V350.768C216.417 302.395 155.403 283.263 102.035 277.536C147.237 249.459 202.597 233.018 270 238.365Z" fill="url(#paint3_radial_2_16)"/>
                  <path d="M270 350.768V531.269H0V378.909C26.1156 340.471 59.6043 303.878 102.035 277.533C155.406 283.263 216.417 302.395 270 350.768Z" fill="url(#paint4_radial_2_16)"/>
                  <path d="M270 0V24.3259C269.7 24.3382 269.396 24.3535 269.093 24.3719C268.296 24.4087 267.484 24.4516 266.654 24.5006C266.307 24.519 265.961 24.5404 265.609 24.5588C264.009 24.6508 262.348 24.758 260.635 24.8775C260.172 24.9082 259.706 24.9419 259.238 24.9756C258.98 24.994 258.72 25.0154 258.462 25.0338C257.73 25.089 256.985 25.1441 256.231 25.2054C255.646 25.2545 255.058 25.3004 254.46 25.3525C254.123 25.3801 253.789 25.4108 253.449 25.4383C253.099 25.4659 252.75 25.4996 252.395 25.5303C251.874 25.5793 251.346 25.6222 250.819 25.6743C250.289 25.7233 249.756 25.7724 249.22 25.8245C248.683 25.8766 248.141 25.9287 247.599 25.9838C246.78 26.0666 245.956 26.1493 245.122 26.2382C244.568 26.2964 244.007 26.3516 243.446 26.4159C242.665 26.5017 241.871 26.5875 241.071 26.6825C240.933 26.6978 240.786 26.7132 240.645 26.7316C239.625 26.8511 238.592 26.9736 237.55 27.1024C237.366 27.1238 237.179 27.1483 236.992 27.1698C235.954 27.3015 234.902 27.4333 233.842 27.5712C233.315 27.6417 232.788 27.7122 232.255 27.7827C231.194 27.9267 230.122 28.0738 229.04 28.227C228.501 28.3036 227.958 28.3833 227.41 28.463C226.785 28.5519 226.159 28.6438 225.528 28.7419C224.584 28.8828 223.631 29.0299 222.672 29.177C221.716 29.3272 220.751 29.4804 219.779 29.6398C217.836 29.9554 215.869 30.2864 213.871 30.6418C212.541 30.8747 211.202 31.1168 209.853 31.3651C207.828 31.742 205.777 32.1373 203.703 32.548C203.013 32.6889 202.321 32.8299 201.625 32.9678C200.234 33.2528 198.833 33.5439 197.424 33.8442C196.014 34.1476 194.595 34.4602 193.167 34.7789C192.456 34.9383 191.739 35.1007 191.022 35.2662C188.999 35.732 186.962 36.2131 184.905 36.7187C184.77 36.7494 184.636 36.7861 184.501 36.8168C183.771 36.9945 183.036 37.1784 182.303 37.3623C181.577 37.5431 180.848 37.73 180.118 37.9169C178.635 38.2969 177.146 38.6892 175.644 39.0906C174.985 39.2653 174.324 39.4461 173.655 39.6269C173.573 39.6484 173.487 39.676 173.404 39.6974C172.653 39.9027 171.906 40.1081 171.155 40.3195C169.81 40.6964 168.464 41.0795 167.113 41.4718C166.714 41.5851 166.313 41.7047 165.915 41.8242C163.448 42.5443 160.965 43.2982 158.471 44.0827C158.033 44.2175 157.591 44.3585 157.153 44.4964C156.485 44.7079 155.814 44.9193 155.146 45.1369C154.374 45.3851 153.601 45.6364 152.829 45.8938C152.25 46.0807 151.668 46.2769 151.092 46.4699C149.973 46.8407 148.851 47.2207 147.73 47.6099C147.096 47.8244 146.464 48.0451 145.83 48.2657C145.107 48.517 144.377 48.7744 143.651 49.0318C143.041 49.2494 142.428 49.4701 141.818 49.6907C141.362 49.8531 140.902 50.0186 140.449 50.1872C138.582 50.8675 136.713 51.5662 134.838 52.2833C134.356 52.4641 133.875 52.651 133.394 52.8379C132.821 53.0586 132.251 53.2823 131.678 53.506C130.93 53.8002 130.186 54.0944 129.438 54.3916C127.314 55.2405 125.184 56.1108 123.055 57.0087C122.478 57.2477 121.899 57.4898 121.326 57.7381C119.598 58.4705 117.863 59.2243 116.129 59.9966C115.553 60.2479 114.974 60.5084 114.397 60.7688C113.239 61.2898 112.084 61.8138 110.922 62.3532C110.368 62.6045 109.81 62.865 109.252 63.1285C107.493 63.9498 105.734 64.7864 103.978 65.6445C103.399 65.9233 102.82 66.2053 102.244 66.4964C101.664 66.7814 101.082 67.0664 100.506 67.3606C99.9085 67.6578 99.3109 67.9581 98.7103 68.2646C98.1526 68.5465 97.5918 68.8315 97.034 69.1226C96.4548 69.4168 95.8757 69.7172 95.2995 70.0205C94.4292 70.4741 93.565 70.9276 92.6978 71.3904C92.6947 71.3904 92.6947 71.3904 92.6947 71.3934C91.8244 71.8531 90.9602 72.3189 90.093 72.7878C89.5138 73.0973 88.9346 73.4129 88.3584 73.7347C87.7793 74.0473 87.2001 74.366 86.627 74.6908C86.0478 75.0095 85.4686 75.3313 84.8956 75.6592C84.0283 76.1434 83.1641 76.6398 82.3 77.1363C81.4327 77.6297 80.5716 78.1353 79.7074 78.641C85.153 50.8981 88.3983 24.3811 90.1542 0H270Z" fill="url(#paint5_radial_2_16)"/>
                  <path d="M70.6243 117.68C56.8095 169.264 34.6962 223.46 0 274.974V154.882C21.0439 141.913 44.8151 128.975 70.6243 117.68Z" fill="url(#paint6_radial_2_16)"/>
                  <path d="M79.6767 78.641C77.1547 91.423 74.1637 104.465 70.6242 117.68C44.8151 128.975 21.0439 141.913 0 154.882V144.092C0.376932 143.657 0.759994 143.228 1.13999 142.799C1.51999 142.367 1.90305 141.941 2.28305 141.512C2.71207 141.037 3.1411 140.559 3.57013 140.087C3.91029 139.713 4.25045 139.342 4.58754 138.975C5.74285 137.715 6.9043 136.465 8.07493 135.233C8.46412 134.822 8.85331 134.409 9.24557 134.004C10.168 133.042 11.0935 132.083 12.0251 131.136C12.2763 130.881 12.5307 130.624 12.782 130.37C13.4715 129.671 14.1641 128.975 14.8597 128.286C15.157 127.992 15.4573 127.694 15.7545 127.403C16.5207 126.646 17.2899 125.902 18.0621 125.157C18.3931 124.835 18.724 124.516 19.0581 124.198C21.8161 121.565 24.6017 119 27.4088 116.503C27.7704 116.181 28.129 115.862 28.4906 115.547C28.8859 115.2 29.2781 114.854 29.6735 114.508C32.1557 112.341 34.6594 110.23 37.1784 108.164C37.5952 107.824 38.015 107.481 38.4318 107.144C38.7106 106.917 38.9895 106.69 39.2684 106.467C39.6331 106.172 39.9977 105.878 40.3655 105.59C40.5585 105.434 40.7547 105.278 40.9477 105.124C41.3676 104.793 41.7874 104.459 42.2072 104.128C43.0469 103.463 43.8927 102.811 44.7354 102.161C45.1522 101.839 45.569 101.52 45.9857 101.202C49.8041 98.2935 53.65 95.4926 57.5235 92.7989C57.9526 92.4986 58.3847 92.2013 58.8137 91.9071C59.6748 91.3096 60.5359 90.7242 61.4001 90.142C61.8322 89.8509 62.2643 89.5628 62.6964 89.2717C64.8599 87.8252 67.0265 86.4125 69.1993 85.0366C70.0696 84.4849 70.9368 83.9364 71.8071 83.394C72.3404 83.063 72.8736 82.729 73.4037 82.4072C74.0289 82.0242 74.651 81.6411 75.2761 81.2642C76.3027 80.6359 77.3324 80.02 78.359 79.4163C78.8003 79.1558 79.2416 78.8984 79.6767 78.641Z" fill="url(#paint7_radial_2_16)"/>
                  <path d="M90.1542 0C88.3983 24.3811 85.153 50.8981 79.6798 78.641C79.2416 78.8953 78.8034 79.1527 78.3682 79.4163C77.3416 80.02 76.3119 80.6359 75.2853 81.2642C74.6602 81.638 74.0381 82.0211 73.4129 82.4072C72.8828 82.729 72.3496 83.06 71.8163 83.394C70.946 83.9364 70.0788 84.4849 69.2085 85.0365C67.0357 86.4156 64.8661 87.8283 62.7056 89.2717C62.2735 89.5628 61.8414 89.8509 61.4093 90.142C60.5451 90.7212 59.684 91.3096 58.8229 91.9071C58.3939 92.2044 57.9618 92.5016 57.5327 92.7989C53.6562 95.4926 49.8102 98.2935 45.9949 101.202C45.5782 101.52 45.1614 101.839 44.7446 102.161C43.9019 102.811 43.0561 103.466 42.2164 104.128C41.7966 104.459 41.3767 104.793 40.9569 105.124C40.7639 105.278 40.5677 105.434 40.3747 105.59C40.01 105.881 39.6453 106.172 39.2776 106.467C38.9987 106.69 38.7198 106.917 38.441 107.144C38.0242 107.481 37.6044 107.824 37.1876 108.164C34.6686 110.23 32.1649 112.341 29.6827 114.508C29.2873 114.851 28.8951 115.197 28.4998 115.547C28.1382 115.862 27.7796 116.181 27.418 116.503C24.6079 119 21.8222 121.565 19.0673 124.198C18.7332 124.516 18.4023 124.835 18.0713 125.157C17.299 125.902 16.5299 126.646 15.7637 127.403C15.4665 127.697 15.1662 127.995 14.8689 128.286C14.1733 128.975 13.4776 129.671 12.7912 130.37C12.5399 130.624 12.2855 130.881 12.0343 131.136C11.1026 132.083 10.1772 133.039 9.25476 134.004C8.86251 134.409 8.47332 134.822 8.08413 135.233C6.91349 136.465 5.74898 137.715 4.59674 138.975C4.25658 139.345 3.91642 139.716 3.57933 140.087C3.1503 140.559 2.72433 141.037 2.29224 141.512C1.91224 141.941 1.52918 142.367 1.14918 142.799C0.769187 143.225 0.386126 143.657 0.00919342 144.092V0H90.1542Z" fill="url(#paint8_radial_2_16)"/>
                  </g>
                  <defs>
                  <radialGradient id="paint0_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(18.214 73.9332) scale(315.823 311.721)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint1_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-85.46 -72.34) scale(634.183 625.945)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint2_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-16.6109 421.255) scale(152.547 150.566)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint3_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(237.484 524.368) scale(288.413 284.666)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint4_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-86.2611 512.912) scale(428.146 422.585)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint5_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(358.91 -19.5138) scale(352.417 347.84)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint6_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-74.6527 159.016) scale(160.558 158.472)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint7_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-152.042 59.721) scale(278.79 275.168)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <radialGradient id="paint8_radial_2_16" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-74.6524 -89.2213) scale(476.393 470.205)">
                  <stop stop-color="#FFFF6F"/>
                  <stop offset="1" stop-color="#FF6A00"/>
                  </radialGradient>
                  <clipPath id="clip0_2_16">
                  <rect width="270" height="310" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                  
                )}
              </div>
              {submitted && (
                <div className="wcf-thankyou">
                  <div className="wcf-thankyou-content">
                    <svg
                      className="wcf-thankyou-close"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      onClick={() => setState({ submitted: false })}
                    >
                      <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="Wcf-thankyou-icon"
                    >
                      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" />
                    </svg>
                    <p>{btnSubmisisonThankYouMsg}</p>
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </form>
      </Fragment>
    );
  }
}

export default EditBlock;
